import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

// Define the valid language codes here
export const SUPPORTED_LANGUAGES = [
  { code: "zh", label: "繁" },  // Traditional Chinese
  { code: "cn", label: "简" },  // Simplified Chinese
  { code: "en", label: "Eng" } // English
];

// Get stored language with null check
const storedLanguage = localStorage.getItem("language");
const defaultLang = "en";

// Verify stored language is valid, otherwise use default
const validLanguage = storedLanguage &&
SUPPORTED_LANGUAGES.some(lang => lang.code === storedLanguage)
  ? storedLanguage
  : defaultLang;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    fallbackLng: defaultLang,
    lng: validLanguage, // Now guaranteed to be a string, not null
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    if (!storedLanguage) {
      localStorage.setItem("language", i18n.language || defaultLang);
    }
    // console.log(`i18n initialized with language: ${i18n.language}`);
  });

export default i18n;